export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-zerply-21150373474661087ffc609ee5b1955f.svg";